
<h3 class="title-form">*RENTA IMPONIBLE Y DETERMINACIÓN DEL IMPUESTO</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Ventas:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.goodsSales+form.servicesSales)" style="text-align:right;">
			{{form.goodsSales+form.servicesSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Resúmen de Retenciones de ISR:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdings)" style="text-align:right;">
			{{form.withholdings | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>